<div class="td-card td-highlights-card" *ngIf="highlights.length">
  <div class="td-card-header">
    <span class="td-card-title">{{ titleKey | translate }}</span>
  </div>

  <div class="td-highlights-list">
    <div class="td-highlight" *ngFor="let highlight of highlights; trackBy: trackByUuid">
      <span class="td-highlight-icon" [ngStyle]="{'background-color': highlight.color}" [ngSwitch]="highlight.icon">
        <svg *ngSwitchCase="'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#FFFFFF">
          <path d="M640-240v-80h104L536-526 376-366 80-664l56-56 240 240 160-160 264 264v-104h80v240H640Z"/>
        </svg>
        <svg *ngSwitchCase="'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#FFFFFF">
          <path d="m136-240-56-56 296-298 160 160 208-206H640v-80h240v240h-80v-104L536-320 376-480 136-240Z"/>
        </svg>
        <svg *ngSwitchCase="'critical'" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#FFFFFF">
          <path d="M324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM707-253q93-93 93-227t-93-227q-93-93-227-93t-227 93q-93 93-93 227t93 227q93 93 227 93t227-93Zm-397-57q-70-70-70-170t70-170q70-70 170-70t170 70q70 70 70 170t-70 170q-70 70-170 70t-170-70Zm283-57q47-47 47-113t-47-113q-47-47-113-47t-113 47q-47 47-47 113t47 113q47 47 113 47t113-47Zm-169.5-56.5Q400-447 400-480t23.5-56.5Q447-560 480-560t56.5 23.5Q560-513 560-480t-23.5 56.5Q513-400 480-400t-56.5-23.5Z"/>
        </svg>
        <span class="td-highlight-dot" *ngIf="highlight.isNew"></span>
      </span>
      <div class="td-highlight-text">
        <span class="td-highlight-title">{{ highlight.title }}</span>
        <span class="td-highlight-description">{{ highlight.description }}</span>
      </div>
      <button type="button" class="td-highlight-dismiss" aria-label="Dismiss" (click)="onDismiss(highlight)">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>
</div>
